(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customizer_button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const customizerButton = document.querySelector('[data-customizer-product-link]');

  if (customizerButton) {
    customizerButton.addEventListener('click', function (event) {
      event.preventDefault();
      const optionSize = document.querySelector(".option--size input:checked");
      const customizerUrl = this.getAttribute('data-customizer-product-link');

      window.location.href = customizerUrl + '?view=customizer&size=' + optionSize.value;
      return false;
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["events-script-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const DESKTOP_MIN_WIDTH = 768;
		let swiper = null;

		const swiperConfig = {
			spaceBetween: 40,
			slidesPerView: 1.2,
  		loop: false,
			mousewheel: { releaseOnEdges: true },
			breakpoints: {
				768:  { slidesPerView: 3.2, spaceBetween: 50 },
				1280: { slidesPerView: 4.2, spaceBetween: 75 }
			}
		};

		function setupSwiper() {
			// if (window.innerWidth >= DESKTOP_MIN_WIDTH && !swiper) {
			// 	swiper = new Swiper('.swiperPastEvents', swiperConfig);
			// 	swiper.mousewheel.disable();
			// }
			// if (window.innerWidth < DESKTOP_MIN_WIDTH && swiper) {
			// 	swiper.destroy(true, true);
			// 	swiper = null;
			// }
			if (!swiper) {
				swiper = new Swiper('.swiperPastEvents', swiperConfig);
				swiper.mousewheel.disable();
			}
		}
		function initInnerSwipers() {
			document.querySelectorAll('.swiper-inner').forEach((el) => {
				if (el.querySelectorAll('.swiper-slide').length < 2) return;

				const card = el.closest('.slider-wrapper');
				const prev = card.querySelector('.swiper-button-prev');
				const next = card.querySelector('.swiper-button-next');
				const pag = card.querySelector('.swiper-pagination');

				new Swiper(el, {
					slidesPerView: 1,
					loop: true,
      		nested: true,
					pagination: {
						el: pag,
						clickable: true
					},
					navigation: {
						prevEl: prev,
						nextEl: next
      		}
				});
			});
		}
		setupSwiper();
		initInnerSwipers();
		window.addEventListener('resize', setupSwiper);
  });

  // Event Popups
  const closeEventModal = document.querySelectorAll('.EventPopup__modal-close');
  const eventPopups = document.querySelectorAll('[data-get-ticket]');
  if (eventPopups) {
    eventPopups.forEach((item) => {
      item.addEventListener('click', (event) => {
        console.log(event, event.target.dataset.getTicket);
        const eventId = event.target.dataset.getTicket;
        const modal = document.getElementById(eventId);
        modal && modal.classList.add('open');
        return false;
      });
    });
  }
  if (closeEventModal) {
    closeEventModal.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.target.closest('.EventPopup__modal').classList.remove('open');
        return false;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["how-it-works-tooltip-ai-block"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', () => {
	const target = document.querySelector('[how-it-works-tooltip="true"]');

	const tooltipEl = [...document.querySelectorAll('*')].find(
		el => el.localName.startsWith('how-it-works-tooltip')
	);

	if (tooltipEl && target) {
		target.appendChild(tooltipEl);
	}
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-the-look-custom-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
        if (window.__STL_SCRIPT__) return;
            window.__STL_SCRIPT__ = true;

        const carousel = document.querySelector("shop-the-look-product-list-carousel");
        if (!carousel || !carousel.id) return;

        const nav = document.querySelector(`carousel-navigation[aria-controls="${carousel.id}"]`);
        if (!nav) return;

        const getDots = () => Array.from(nav.querySelectorAll("button"));
        const getActiveIndex = () => getDots().findIndex(d => d.getAttribute("aria-current") === "true");
        const clickDotAt = (i) => { const dots = getDots(); if (dots[i]) dots[i].click(); };

        const goNextByDot = () => {
            const dots = getDots();
            const i = getActiveIndex();
            if (i === -1) return;
            if (i < dots.length - 1) {
                clickDotAt(i + 1);
            } else {
                clickDotAt(0);
            }
        };

        const goPrevByDot = () => {
            const i = getActiveIndex();
            if (i === -1) return;
            if (i > 0) {
                clickDotAt(i - 1);
            } else {
                clickDotAt(getDots().length - 1);
            }
        };

        document.getElementById("nextSlide")?.addEventListener("click", goNextByDot);
        document.getElementById("prevSlide")?.addEventListener("click", goPrevByDot);
    });
  } catch(e) { console.error(e); }
})();

})();
